export default __webpack_public_path__ + "static/media/portfolio-instagram.bdb24d09.png";